export const getTherapistEndpoint = ({
  therapistId,
}: {
  therapistId: string;
}) => `therapists/${therapistId}`;
